import { api } from "../../lib";

export interface CptModifier {
  id: string;
  code: string;
  description: string;
  billingScenarioId: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  billingScenario?: { id: string; name: string; description: string } | null;
}

export interface CreateCptModifierInput {
  code: string;
  description: string;
  billingScenarioId?: string | null;
  isActive?: boolean;
}

export interface UpdateCptModifierInput
  extends Partial<CreateCptModifierInput> {
  id: string;
}

export const cptModifiersService = {
  getAll: async () => {
    return api.get<CptModifier[]>("/admin/cpt-modifiers");
  },

  getById: async (id: string) => {
    return api.get<CptModifier>(`/admin/cpt-modifiers/${id}`);
  },

  create: async (input: CreateCptModifierInput) => {
    return api.post<CptModifier>("/admin/cpt-modifiers", input);
  },

  update: async (input: UpdateCptModifierInput) => {
    const { id, ...updates } = input;
    return api.put<CptModifier>(`/admin/cpt-modifiers/${id}`, updates);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/cpt-modifiers/${id}`);
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.put<CptModifier>(`/admin/cpt-modifiers/${id}`, {
      isActive,
    });
  },
};
